import { PublicClientApplication } from '@azure/msal-browser';

import { authConfig } from '../../config/auth';

const msalInstance = new PublicClientApplication(authConfig);

export default msalInstance;
